export const BuildCell = ({ txt }: { txt: string | number }) => {
    return <span style={{fontSize: 10}}>{txt}</span>
}
